<template>
  <div class="jgsd-report-review">
    <div class="item">
      <div class="hd">
        总体审校结果分析
        <div class="hd_status">
          共计审校稿件{{ sum }}篇，存在可疑内容稿件
          <em @click="toDetail('审校类型')">{{ suspicious }}</em>
          篇，可疑内容占比<em>{{ susProportion }}%</em>，检校差错数量<em>{{
            suspiciousSum
          }}</em>处。
        </div>
      </div>
      <div class="bd">
        <pie
          class="bd_item"
          echarts-id="total"
          :data-list="totalPie"
          :color="['#4976F6', '#5FD4C0']"
          echarts-title="可疑数据"
        />
        <pie
          class="bd_item"
          echarts-id="system1"
          :data-list="folderPie"
          :color="[
            '#EA5534',
            '#F39B3E',
            '#1F9DE5',
            '#5BE1E6',
            '#9D85EE',
            '#51D9B7',
            '#53C971'
          ]"
          echarts-title="互联网可疑数据"
        />
        <pie
          class="bd_item"
          echarts-id="system0"
          :data-list="articlePie"
          :color="[
            '#EA5534',
            '#F39B3E',
            '#1F9DE5',
            '#5BE1E6',
            '#9D85EE',
            '#51D9B7'
          ]"
          echarts-title="上传可疑数据"
        />
      </div>
    </div>
    <div class="item">
      <div class="hd">
        审校类型统计
      </div>
      <div class="bd">
        <div class="bd_ul">
          <ul>
            <li class="bd_ul-hd">
              <span>类型</span><span>稿件量</span>
            </li>
            <li
              v-for="(item, index) in inspectTypeFirstColumn"
              :key="index"
            >
              <span>{{ item.name
              }}<i
                :style="{ background: inspectTypeCyColors[item.index] }"
              /></span>
              <span><em @click="toDetail(item.name)">{{ item.value }}</em>篇</span>
            </li>
          </ul>
          <ul>
            <li class="bd_ul-hd">
              <span>类型</span><span>稿件量</span>
            </li>
            <li
              v-for="(item, index) in inspectTypeSecondColumn"
              :key="index"
            >
              <span>{{ item.name
              }}<i
                :style="{ background: inspectTypeCyColors[item.index] }"
              /></span>
              <span><em @click="toDetail(item.name)">{{ item.value }}</em>篇</span>
            </li>
            <li
              v-if="!isExpand"
              @click="redraw"
            >
              <el-button>
                <i class="el-icon-caret-bottom" />显示其余项
              </el-button>
            </li>
          </ul>
        </div>
        <pie
          ref="echartError"
          class="bd_item"
          echarts-id="4"
          :data-list="inspectTypeData"
          :is-show-legend="false"
          :is-show-echarts-title="false"
          echarts-title="审校类型统计"
        />
      </div>
    </div>
    <div class="item">
      <div class="hd">
        各机构可疑内容分布
      </div>
      <reviewTable
        class="depart-table"
        :thead="thead"
        :tpropty="tpropty"
        :table-data="tableData"
        @handleRowClick="handleRowClick"
      />
    </div>
    <detailDialog
      ref="detailDialog"
      :is-show-department="false"
      :is-show-inspect-type="true"
      :is-show-source="true"
      :is-direct-search="true"
      :thead="detailThead"
      :tpropty="detailTpropty"
      download-url="/mbd-special/shendu/statistics/reviewExport"
      title="稿件列表"
      apis="postStatisticsFindByReviewTypeList"
      :article-type="articleType"
      :folder-type="folderType"
      :base-params="baseParams"
    />
  </div>
</template>

<script>
import { cyColors, getPercentValue } from '@common/util.js'
import pie from '@components/echarts/pie'
import reviewTable from '@components/jgsd/table'
import detailDialog from './detailDialog.vue'
import APIS from '@apis/jgsd/report.js'
import { inspectTypeArrPie } from '../data/type.js'
export default {
  name: 'Check',
  props: {
    indicatorData: {
      type: Object,
      default: () => {}
    },
    getTimeParams: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    pie,
    reviewTable,
    detailDialog
  },
  data() {
    return {
      sum: 0,
      suspiciousSum: 0,
      totalType: {
        system1: '互联网数据',
        system0: '上传数据'
      },
      totalPie: [],
      articleType: {
        '1': '图文',
        '2': '图集',
        '3': '书籍文件',
        '4': '影视作品',
        '5': '视频',
        '6': '音频'
      },
      articlePie: [],
      folderType: {
        news: '网站',
        app: 'APP',
        weibo: '微博',
        wechat: '微信',
        epaper: '数字报',
        wemedia: '自媒体',
        video: '短视频'
      },
      folderPie: [],
      isExpand: false,
      inspectTypeCyColors: cyColors(),
      inspectTypeData: [],
      thead: [
        '',
        '所属机构',
        '审校稿件量',
        '可疑稿件',
        '互联网-可疑稿件',
        '上传-可疑稿件'
      ],
      tpropty: ['index', 'name', 'total', 'sum', 'system1', 'system0'],
      tableData: [],
      baseParams: {},
      detailThead: [
        '标题',
        { label: '稿件类型', width: 90 },
        { label: '时间', width: 150 },
        '媒体名称',
        { label: '所属机构', width: 150 },
        { label: '可疑内容数量', width: 110 },
        { label: '操作', width: 120 }
      ],
      detailTpropty: [
        'title',
        'type',
        'pubdate',
        'source',
        'department',
        'suspiciousCount',
        'btns'
      ]
    }
  },
  computed: {
    suspicious() {
      if (this.totalPie.length === 0) return 0
      return this.totalPie.reduce((a, b) => {
        return b.value + a
      }, 0)
    },
    susProportion() {
      return getPercentValue([this.suspicious, this.sum - this.suspicious], 0)
    },
    totalKeys() {
      return Object.keys(this.totalType)
    },
    articleKeys() {
      return Object.keys(this.articleType)
    },
    folderKeys() {
      return Object.keys(this.folderType)
    },
    inspectTypeFirstColumn() {
      return this.inspectTypeData.slice(0, this.isExpand ? 9 : 5)
    },
    inspectTypeSecondColumn() {
      return this.inspectTypeData.slice(9, this.isExpand ? 18 : 13)
    },
    allInspectType() {
      return this.inspectTypeData.map(item => item.name).join(',')
    }
  },
  created() {
    this.inspectTypeData = inspectTypeArrPie.map((item, index) => {
      return {
        name: item.name,
        index: index,
        value: 0
      }
    })
    this.init()
  },
  methods: {
    init() {
      this.getStatisticsReviewSystem()
      this.getStatisticsArticleType()
      this.getStatisticsFolder()
      this.getStatisticsReviewByType()
      this.getStatisticsDepartment()
    },
    // 可疑内容统计
    async getStatisticsReviewSystem() {
      let { status, data } = await APIS.postStatisticsReviewSystem({
        data: this.getTimeParams
      })
      this.totalPie = this.totalKeys.map(item => {
        return {
          name: this.totalType[item],
          value:
            status !== 0 || JSON.stringify(data) === '{}'
              ? 0
              : data[item.slice(6)] || 0
        }
      })
      this.sum = data.sum || 0
      this.suspiciousSum = data.suspiciousSum || 0
    },
    // 上传可疑数据统计
    async getStatisticsArticleType() {
      let { status, data } = await APIS.postStatisticsReviewGroup({
        data: Object.assign({}, this.getTimeParams, {
          oriSystem: 0,
          group: 'articleTypeId'
        })
      })
      this.articlePie = this.articleKeys.map(item => {
        return {
          name: this.articleType[item],
          value:
            status !== 0 || JSON.stringify(data) === '{}' ? 0 : data[item] || 0
        }
      })
    },
    // 互联网可疑数据统计
    async getStatisticsFolder() {
      let { status, data } = await APIS.postStatisticsReviewGroup({
        data: Object.assign({}, this.getTimeParams, {
          oriSystem: 1,
          group: 'folder'
        })
      })
      this.folderPie = this.folderKeys.map(item => {
        let video =
          (data.video || 0) +
          (data.douyin || 0) +
          (data.kuaishou || 0) +
          (data.miaopai || 0) +
          (data.bilibili || 0)
        return {
          name: this.folderType[item],
          value:
            status !== 0 || JSON.stringify(data) === '{}'
              ? 0
              : item === 'video'
                ? video
                : data[item] || 0
        }
      })
    },
    // 审校类型统计
    async getStatisticsReviewByType() {
      let { status, data } = await APIS.postStatisticsReviewByType({
        data: Object.assign({}, this.getTimeParams, {
          reviewType: this.allInspectType
        })
      })
      this.inspectTypeData = this.inspectTypeData.map((item, index) => {
        let curIndex = data && data.findIndex(i => i.name === item.name)
        return {
          name: item.name,
          index: index,
          value:
            status !== 0 || data.length === 0 || curIndex === -1
              ? 0
              : data[curIndex].count
        }
      })
    },
    // 各机构可疑内容分布
    async getStatisticsDepartment() {
      let { status, data } = await APIS.postStatisticsReviewDepartment({
        data: this.getTimeParams
      })
      if (status === 0 && data && data.length !== 0) {
        this.tableData = data.map((item, index) => {
          return {
            index: index + 1,
            id: item.departmentId,
            name: item.departmentName,
            total: item.sum || 0,
            sum: (item.reviewSystem0 || 0) + (item.reviewSystem1 || 0),
            system0: item.reviewSystem0 || 0,
            system1: item.reviewSystem1 || 0
          }
        })
      } else {
        this.tableData = []
      }
    },
    toDetail(type) {
      this.baseParams = Object.assign({}, this.getTimeParams)
      this.$refs.detailDialog.$refs.dialogCommon.cyDialogCommon = true
      this.$nextTick(() => {
        this.$refs.detailDialog.init({ inspectType: type || '审校类型' })
      })
    },
    handleRowClick(value) {
      if (
        value.prop !== 'system1' &&
        value.prop !== 'system0' &&
        value.prop !== 'sum'
      ) {
        return false
      }
      if (value[value.prop] === 0) return false
      let isInterNet = value.prop === 'system1'
      this.baseParams = Object.assign({}, this.getTimeParams, {
        system: isInterNet ? 1 : value.prop === 'sum' ? undefined : 0
      })
      this.$refs.detailDialog.$refs.dialogCommon.cyDialogCommon = true
      this.$nextTick(() => {
        this.$refs.detailDialog.init({ id: value.id, name: value.name })
      })
    },
    redraw() {
      this.isExpand = !this.isExpand
      this.$refs.echartError.myChart.resize({ height: 470 })
    }
  },
  watch: {
    getTimeParams: {
      handler(newVal) {
        if (!newVal) return false
        this.init()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.jgsd-report-review {
  .item {
    .hd {
      flex-wrap: wrap;
      &_status {
        display: flex;
        width: 100%;
        align-items: center;
        padding: 0 12px;
        margin-top: 9px;
        height: 28px;
        background: #f5f7f8;
        font-size: 12px;
        color: #666;
        border-radius: 3px;
        em {
          color: #4497ec;
          font-style: normal;
          &:nth-child(1) {
            cursor: pointer;
          }
        }
      }
      &::before {
        top: 19px;
      }
    }
    .bd {
      &_ul {
        display: flex;
        margin-right: 20px;
        width: 620px;
        justify-content: space-between;
        &-hd {
          font-size: 13px;
        }
        ul {
          width: 290px;
          border-top: 1px solid #eeeeee;
          li {
            display: flex;
            justify-content: space-between;
            height: 47px;
            padding: 0 15px 0 10px;
            align-items: center;
            font-size: 12px;
            border-bottom: 1px dashed #eeeeee;
            em {
              margin-right: 3px;
              font-style: normal;
              color: #4497ec;
              cursor: pointer;
            }
            span {
              &:first-child {
                display: inline-flex;
                width: 168px;
                justify-content: space-between;
                align-items: center;
                i {
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                }
              }
            }
            &.bd_ul-hd {
              font-size: 13px;
            }
            .el-button {
              width: 100%;
              height: 25px;
              background: #f5f5f5;
              font-size: 12px;
              color: #4497ec;
              border: none;
              i {
                margin-right: 15px;
              }
            }
          }
        }
      }
    }
    &:nth-child(2) {
      .bd {
        .bd_item {
          &.echartsPie {
            flex: 1;
            border: none;
          }
        }
      }
    }
  }
  /deep/ .el-table {
    &.depart-table {
      .cell {
        .sum {
          cursor: pointer;
          &.disabled {
            cursor: auto;
          }
        }
      }
    }
  }
}
</style>
